module.exports = __webpack_public_path__ + "img/Airbnb-Work-From-Home-Couches-Landing-page-Footer-and-Page2-scaled.04470189.jpg";